module.exports = __webpack_public_path__ + "static/media/29EUNOG17.af974954.jpg";